/* eslint-disable react/function-component-definition */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'

import Hero from '../components/elements/Hero'

// Images
import LogoSlider from '../components/LogoSlider'
import HeroIntro from '../components/elements/HeroIntro'
import ServicesGrid from '../components/elements/ServicesGrid'
import Concepts from '../components/elements/Concepts'
import DefaultQuote from '../components/elements/QuoteDefault'
import CtaDefault from '../components/elements/CtaDefault'
import Samenwerking from '../components/elements/Samenwerking'

export const pageQuery = graphql`
  query ($id: String) {
    page: wpPage(id: { eq: $id }) {
      title
      uri
      pageServices {
        headerdiensten {
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
                meta: fluid(maxWidth: 800, toFormat: JPG) {
                  src
                }
              }
            }
          }
          title
          titleunder
          link {
            title
            url
          }
          link2 {
            title
            url
          }
        }

        introdiensten {
          title
          description
        }

        services {
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 787, quality: 100)
              }
            }
          }
          service {
            icon {
              localFile {
                publicURL
              }
            }
            title
            description
          }
        }

        conceptendiensten {
          title
          blockleft {
            title
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2000, quality: 100)
                }
              }
            }
            links {
              link {
                title
                url
              }
            }
          }
          blockright {
            title
            image {
              localFile {
                childImageSharp {
                  gatsbyImageData(width: 2000, quality: 100)
                }
              }
            }
            links {
              link {
                title
                url
              }
            }
          }
        }
        quotediensten {
          quote
        }

        partners {
          title
        }

        samenwerking {
          intro
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
              }
            }
          }
          description
          link {
            title
            url
          }
          image2 {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
              }
            }
          }
          description2
          link2 {
            title
            url
          }
        }

        cta {
          description
          link {
            title
            url
          }
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 2000, quality: 100)
              }
            }
          }
        }
      }
      seo {
        canonical
        cornerstone
        focuskw
        metaDesc
        metaKeywords
        metaRobotsNofollow
        metaRobotsNoindex
        opengraphAuthor
        opengraphDescription
        opengraphModifiedTime
        opengraphPublisher
        opengraphPublishedTime
        opengraphSiteName
        opengraphTitle
        opengraphType
        opengraphUrl
        title
        twitterDescription
        twitterTitle
        opengraphImage {
          sourceUrl
        }
        twitterImage {
          sourceUrl
        }
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { pageServices, seo },
  },
}) => (
  <Layout subFooter>
    {seo && <SEO seo={seo} />}
    <Hero
      title={pageServices.headerdiensten.title}
      src={pageServices.headerdiensten.image}
    />

    <HeroIntro
      title={pageServices.introdiensten.title}
      description={pageServices.introdiensten.description}
      titleunder={pageServices.headerdiensten.titleunder}
      link={pageServices.headerdiensten.link}
      extraLink={pageServices.headerdiensten.link2}
    />

    <ServicesGrid services={pageServices.services.service} />

    <Concepts
      title={pageServices.conceptendiensten.title}
      blockLeft={pageServices.conceptendiensten.blockleft}
      blockRight={pageServices.conceptendiensten.blockright}
    />

    <DefaultQuote quote={pageServices.quotediensten.quote} />

    <CtaDefault cta={pageServices.cta} />

    <Samenwerking samenwerking={pageServices.samenwerking} />

    <div className="mb-lg-5 pb-lg-5">
      <LogoSlider isPartners title={pageServices.partners.title} />
    </div>
  </Layout>
)

export default PageTemplate
